var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import Stack from '@mui/material/Stack';
import { CancelButton, FormContainer, FormActions, SubmitButton } from '@/components/layout/forms';
import { DescriptionField, StatusToggleButton, ModeButtons, IPv4AddressField, IPv4NetmaskField, IPv4GatewayField, IPv4PrimaryDNSField, IPv4SecondaryDNSField, IPv6AddressField, IPv6PrefixLengthField, IPv6GatewayField, IPv6PrimaryDNSField, IPv6SecondaryDNSField, } from './network-interface-form-controls';
import { useFormSync } from '@/hooks/use-form-sync';
import { useUpdateInterface } from '@/api/interfaces';
export var NETWORK_INTERFACE_MODAL_TITLE_ID = 'network-interface-modal-title-id';
export function InterfaceForm(_a) {
    var _this = this;
    var handleClose = _a.handleClose, data = _a.data, permissions = _a.permissions;
    var t = useTranslation().t;
    var methods = useForm({ mode: 'onTouched', defaultValues: data });
    var updateInterface = useUpdateInterface();
    var handleCancel = useCallback(function () {
        methods.reset();
        handleClose();
    }, [methods, handleClose]);
    var mode = methods.watch('mode');
    var onSubmit = useCallback(function (formData) { return __awaiter(_this, void 0, void 0, function () {
        var updatedData;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, updateInterface(__assign(__assign({}, formData), { id: formData.id }))];
                case 1:
                    updatedData = _a.sent();
                    if (updatedData) {
                        methods.reset(formData);
                        handleClose();
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [handleClose, methods, updateInterface]);
    useFormSync(methods.formState.defaultValues, data, methods.reset, t('pages.network_interfaces.modal.form.update.header'));
    return (_jsxs(FormContainer, __assign({ ariaLabelledBy: NETWORK_INTERFACE_MODAL_TITLE_ID, mode: "update", methods: methods, onSubmit: onSubmit, permissions: permissions }, { children: [_jsx(Stack, __assign({ marginBottom: 2 }, { children: _jsx(StatusToggleButton, {}) })), _jsx(DescriptionField, {}), _jsx(Stack, __assign({ marginBottom: 2 }, { children: _jsx(ModeButtons, {}) })), mode === 'static' && (_jsxs(_Fragment, { children: [_jsx(IPv4AddressField, {}), _jsx(IPv4NetmaskField, {}), _jsx(IPv4GatewayField, {}), _jsx(IPv4PrimaryDNSField, {}), _jsx(IPv4SecondaryDNSField, {})] })), mode === 'ipv6_static' && (_jsxs(_Fragment, { children: [_jsx(IPv6AddressField, {}), _jsx(IPv6PrefixLengthField, {}), _jsx(IPv6GatewayField, {}), _jsx(IPv6PrimaryDNSField, {}), _jsx(IPv6SecondaryDNSField, {})] })), _jsxs(FormActions, { children: [_jsx(CancelButton, { onCancel: handleCancel }), _jsxs(SubmitButton, { children: [" ", t('pages.network_interfaces.modal.form.buttons.update'), " "] })] })] })));
}
